module.exports = __webpack_public_path__ + "static/media/guide_mobile_02.59d593dd.svg";